import app from "flarum/forum/app";

/**
 * Admin-configurable label and icon for the chat.
 *
 * Both the header button and the drawer header read from here, so renaming the
 * feature (to "Lounge", "Radio", whatever) or swapping its icon is one setting
 * rather than a translation override plus a CSS hack.
 */

/** The chat's display name. Falls back to the translated default when unset. */
export function chatTitle() {
  var _app$forum$attribute;
  const custom = ((_app$forum$attribute = app.forum.attribute("ramon-chat.title")) != null ? _app$forum$attribute : "").trim();
  if (custom !== "") return custom;
  return app.translator.trans("ramon-chat.forum.nav.chat", {}, true);
}

/**
 * The Font Awesome class for the chat icon, or null when the admin has turned the
 * icon off.
 *
 * Returning null rather than an empty string keeps the call sites honest: they
 * have to decide what to render without an icon, instead of emitting an `<i>` with
 * no class that collapses to a stray gap.
 */
export function chatIcon() {
  var _app$forum$attribute2;
  if (app.forum.attribute("ramon-chat.showIcon") === false) return null;
  const icon = ((_app$forum$attribute2 = app.forum.attribute("ramon-chat.icon")) != null ? _app$forum$attribute2 : "").trim();
  return icon === "" ? "fas fa-comments" : icon;
}
flarum.reg.add('ramon-chat', 'forum/utils/branding', { chatTitle: chatTitle,chatIcon: chatIcon, });